import React from 'react';
import classes from './CatchHeader.module.scss';
import CatchLogo from '../../../images/catch-logo.png';

const CatchHeader = () => {
    return (
        <div className={classes.CatchImageContainer}>
            <div className={classes.ImgDimentions}>
                <img src={CatchLogo} alt='catch logo' />
            </div>
        </div>
    );
};

export default CatchHeader;